export const SegRecords = {
  EAN: "ISBN",
  SEASON: "SEASON",
  PAPER_CUT_OFF: "PAPER CUT OFF DATE",
  LDC: "LDC",
  GROUP_1: "DIVISION",
  TESTIMPRINTFROMHNA: "IMPRINT",
  FULL_TITLE:"TITLE",
  AUTHOR_1:"AUTHOR NAME",
  PUB_DATE:"PUB DATE",
  RELEASE_DATE:"RELEASE DATE",
  FORMAT:"FORMAT",
  US_PRICE:"US PRICE ($)",
  //Float + Blank
  totalPubGoal:"Laydown Goal (TOTAL)",
  totalCurrentEst:"TOTAL Laydown Estimate",
  estimatePubGoal:"ESTIMATE VS PUB GOAL",
  totalInitOrd:"TOTAL INITIAL ORDERS",
};

export const OTISRecords = {
  account_name: "Account Name",
  sales_notes:"Sales Notes",
  // account_number: "Account Number",
  pubGoal: "Laydown Goal",
  currentEst:"Laydown Estimate",
  initOrd:"INITIAL ORDER",
  suppEst:"6-month Estimate (incl Laydown)",
  compInit:"COMP TITLE INITIAL ORDER",
  compGross:"COMP TITLE GROSS SALES",
  compNet:"COMP TITLE NET SALES",
  retPercentage:"COMP TITLE % RETURNS",
  Cpos_4wk:"COMP TITLE 4wk POS",
  Cpos_8wk:"COMP TITLE 8wk POS",
  Cpos_LTD:"COMP TITLE LTD POS",
};

